<template>
  <div>
    <van-field
      :value="value"
      :readonly="readonly"
      :disabled="disabled"
      :border="border"
      :clearable="clearable"
      :rules="rules"
      :placeholder="placeholder"
      :name="name"
      @input="$emit('input', $event)"
      @focus="focus"
      @blur="blur"
      :class="{ 'field-focus-border': isFocus, 'field-border': !isFocus }"
    />
  </div>
</template>

<script>
import { Field } from "vant";

export default {
  name: "CuField",
  components: {
    VanField: Field
  },
  props: {
    value: String,
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      isFocus: false
    };
  },

  mounted() {
    document.addEventListener("click", e => {
      e.preventDefault();
      if (this.isFocus) {
        // this.blur();
      }
    });
  },

  methods: {
    focus(e) {
      console.log("11", 11);
      this.isFocus = true;
      this.$emit("focus", e);
    },
    blur(e) {
      this.isFocus = false;
      this.$emit("blur", e);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/variableName.scss";
@import "../../../style/mixin";
.field-focus-border {
  /deep/ .van-field__body {
    border: torem(0.5) solid #ffc72b !important;
  }
}
.field-border {
  /deep/ .van-field__body {
    border: torem(0.5) solid #dcdfe6;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/InscriptionArea/compontents/cuField.vue